import { acceptHMRUpdate, defineStore } from 'pinia';
import type { DecoratedProduct } from '~/utils/shop/DecoratedProduct';
import { type ProductInterface } from '~/lib/Shop/generated/schema';
import { formatMoney } from '~/utils/shop/formatMoney';

export type AccessoryAssistantStoreState = {
  selectedProduct: DecoratedProduct | null;
};

/**
 * This store is responsible for logic related to accessory assistant.
 */
export const useAccessoryAssistantStore = defineStore(
  'accessory-assistant-store',
  () => {
    const selectedProduct = ref<ProductInterface | null>(null);

    const { $locale } = useNuxtApp();

    const _state = {
      selectedProduct
    };

    const selectedDecoratedProductPrice = computed<number>(() => {
      return (
        selectedProduct.value?.price_range?.minimum_price?.final_price?.value ??
        0
      );
    });

    const selectedDecoratedProductPriceLabel = computed(() => {
      return `${selectedProduct?.value?.name ?? ''} +${formatMoney(
        selectedProduct?.value?.price_range?.minimum_price?.final_price,
        $locale.value
      )}`;
    });

    function setSelectedDecoratedProduct(product: ProductInterface) {
      selectedProduct.value = product;
    }

    function removeSelectedDecoratedProduct() {
      selectedProduct.value = null;
    }

    return {
      _state,
      selectedProduct,
      selectedDecoratedProductPrice,
      selectedDecoratedProductPriceLabel,
      setSelectedDecoratedProduct,
      removeSelectedDecoratedProduct
    };
  }
);

if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(useAccessoryAssistantStore, import.meta.hot)
  );
}
